/**
 * Glow Up Boo — simple snap slider for card rows
 */
(function () {
  function initSlider(root) {
    var track = root.querySelector('[data-gub-track]');
    if (!track) return;

    var prev = root.querySelector('[data-gub-prev]');
    var next = root.querySelector('[data-gub-next]');
    var dotsWrap = root.querySelector('[data-gub-dots]');
    var slides = Array.prototype.slice.call(track.children).filter(function (el) {
      return !el.classList.contains('is-hidden') && el.offsetParent !== null;
    });

    function visibleSlides() {
      return Array.prototype.slice.call(track.children).filter(function (el) {
        return !el.classList.contains('is-hidden');
      });
    }

    function cardStep() {
      var card = visibleSlides()[0];
      if (!card) return track.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function maxIndex() {
      var cards = visibleSlides();
      if (!cards.length) return 0;
      var overflow = track.scrollWidth - track.clientWidth;
      if (overflow <= 4) return 0;
      return Math.max(0, Math.ceil(overflow / cardStep()));
    }

    function currentIndex() {
      var step = cardStep();
      if (!step) return 0;
      return Math.round(track.scrollLeft / step);
    }

    function goTo(index) {
      var max = maxIndex();
      var i = Math.max(0, Math.min(index, max));
      track.scrollTo({ left: i * cardStep(), behavior: 'smooth' });
      updateUI();
    }

    function updateUI() {
      var i = currentIndex();
      var max = maxIndex();
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= max;
      if (dotsWrap) {
        var dots = dotsWrap.querySelectorAll('button');
        dots.forEach(function (dot, idx) {
          dot.classList.toggle('is-active', idx === i);
          dot.hidden = idx > max;
        });
      }
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var max = maxIndex();
      for (var i = 0; i <= max; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'gub-slider__dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (index) {
          btn.addEventListener('click', function () { goTo(index); });
        })(i);
        dotsWrap.appendChild(btn);
      }
    }

    if (prev) prev.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (next) next.addEventListener('click', function () { goTo(currentIndex() + 1); });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(updateUI, 60);
    }, { passive: true });

    window.addEventListener('resize', function () {
      buildDots();
      updateUI();
    });

    root.gubSliderRefresh = function () {
      buildDots();
      updateUI();
      // After filter hide/show, keep scroll in range
      if (track.scrollLeft > track.scrollWidth - track.clientWidth) {
        track.scrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
      }
    };

    buildDots();
    updateUI();
  }

  function boot() {
    document.querySelectorAll('[data-gub-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
